module.exports = __webpack_public_path__ + "img/main-mob.a7071e90.webp";